var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t("influencer_panel.pix_register"),
        "ok-title": _vm.$t("save"),
        "cancel-title": _vm.$t("action.cancel"),
        "cancel-variant": "outline-secondary",
        "ok-disabled": !_vm.canSubmit,
        centered: "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
        hidden: _vm.reset,
      },
    },
    [
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("influencer_panel.pix_type") } },
        [
          _c("b-form-select", {
            attrs: { options: _vm.typeOptions },
            model: {
              value: _vm.keyType,
              callback: function ($$v) {
                _vm.keyType = $$v
              },
              expression: "keyType",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("influencer_panel.pix_key") } },
        [
          _c("b-form-input", {
            attrs: { type: "text", placeholder: _vm.placeholder },
            model: {
              value: _vm.keyValue,
              callback: function ($$v) {
                _vm.keyValue = $$v
              },
              expression: "keyValue",
            },
          }),
        ],
        1
      ),
      _c(
        "p",
        { staticClass: "pix-form__note" },
        [
          _c("feather-icon", { attrs: { icon: "InfoIcon", size: "14" } }),
          _vm._v(" " + _vm._s(_vm.$t("influencer_panel.pix_hint")) + " "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }